
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-records-ui',
  currentProjectVersion: 'static-1.77261',
  depVersions: {
  "crm-records-ui": "static-1.77261",
  "ably-hubspot-js": "static-1.435",
  "ai-components-ui-library": "static-1.5042",
  "apollo-dlb": "static-3.41",
  "apollo-link-hub-http": "static-2.3467",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3187",
  "call-widget-addon": "static-2.27178",
  "calling-global-api": "static-1.57070",
  "calling-internal-common": "static-1.29895",
  "calling-lifecycle-internal": "static-1.58452",
  "card-associated-objects-lib": "static-1.38249",
  "card-associated-objects-lib-legacy": "static-1.5876",
  "card-linked-in-sales-navigator-lib": "static-1.35289",
  "card-preview-highlight-lib": "static-1.69852",
  "card-properties-lib": "static-1.38342",
  "client-types": "static-1.372",
  "commerce-contract-lib": "static-1.5656",
  "copilot-toolkit": "static-1.5788",
  "crm_data": "static-4.86319",
  "crm_ui": "static-5.86277",
  "crm-activity-creator-data": "static-1.40798",
  "crm-activity-creator-interactions-legacy": "static-1.30720",
  "crm-activity-creator-widgets": "static-1.46302",
  "crm-cards": "static-1.38888",
  "crm-cards-sdk": "static-1.37591",
  "crm-cards-test-utils": "static-1.37438",
  "crm-command-handler": "static-1.30241",
  "crm-common-dlb": "static-1.3997",
  "crm-events-data": "static-1.55020",
  "crm-fe-perf": "static-1.21679",
  "crm-legacy-global-containers": "static-1.22463",
  "crm-links": "static-1.4774",
  "crm-message-bus": "static-1.36173",
  "crm-object-map": "static-1.1659",
  "crm-pipeline-approvals-lib": "static-1.18773",
  "crm-timeline": "static-1.83346",
  "crm-timeline-tasks": "static-1.32243",
  "customer-data-communicator": "static-1.39765",
  "customer-data-email": "static-1.15596",
  "customer-data-objects": "static-1.6287",
  "customer-data-properties-shared-msw-handlers": "static-1.6248",
  "customer-data-sidebar": "static-2.40468",
  "customer-data-tracking": "static-1.5478",
  "data-fetching-client": "static-1.8302",
  "dispatcher": "static-1.111",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.300",
  "feedback-loader": "static-1.26336",
  "foundations-components": "static-1.5854",
  "foundations-theming-specialty": "static-1.710",
  "framework-data-schema-quick-fetch": "static-1.5453",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7004",
  "framework-data-table": "static-2.8364",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.3911",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6669",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3506",
  "hubspot-dlb": "static-2.1371",
  "HubStyleTokens": "static-2.10176",
  "I18n": "static-7.1380",
  "immutable": "static-2.19",
  "jasmine-console-invariants": "static-1.1394",
  "jasmine-immutable": "static-1.1646",
  "jasmine-runner": "static-1.5083",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.4805",
  "MeetingsLib": "static-2.53025",
  "msw": "static-1.39",
  "multi-currency-client-types": "static-1.2729",
  "onboarding-tours": "static-1.14025",
  "PortalIdParser": "static-2.278",
  "quartz": "static-1.5431",
  "quartz-core": "static-1.4650",
  "quick-fetch": "static-1.2875",
  "quotes-ui-lib": "static-1.73724",
  "raven": "static-3.4646",
  "react": "static-7.151",
  "react-dlb": "static-1.51",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-dom": "static-7.85",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4217",
  "recording-review-components-lib": "static-1.26049",
  "reference-resolvers": "static-1.6833",
  "reporting-dlb": "static-1.54090",
  "reporting-testing-lib": "static-1.3107",
  "sales-clients-common": "static-1.45155",
  "settings-ui-lib": "static-1.11237",
  "tinymce": "static-6.5",
  "ui-addon-avatars": "static-2.8111",
  "ui-addon-draggable": "static-2.1197",
  "ui-addon-opt": "static-4.7337",
  "UIComponents": "static-3.7124",
  "universal-associations-select": "static-1.9467",
  "usage-based-billing-components-lib": "static-1.3184",
  "usage-tracker": "static-1.6143",
  "usage-tracker-core": "static-1.5993",
  "webpack-env": "static-1.54",
  "ai-catchup-cards-lib": "static-1.2195",
  "BizOpsCrmUIComponents": "static-1.40180",
  "call-timeline-event": "static-1.50373",
  "calling-error-reporting": "static-1.29901",
  "calling-integration-timeline-event": "static-1.12966",
  "calling-orchestration-shared-library": "static-1.29717",
  "calling-ui-library": "static-1.64371",
  "card-deal-collaborators-lib": "static-1.32370",
  "chatspot-widget-iframe": "static-1.14981",
  "commerce-billing-lib": "static-1.14292",
  "commerce-subscription-lib": "static-1.30758",
  "commerce-tools-ui-lib": "static-1.6149",
  "composer-plugins": "static-1.66367",
  "conversations-inbox-message-history": "static-1.29421",
  "conversations-message-history": "static-1.9772",
  "conversations-thread-view-crm-events": "static-1.29032",
  "crm_components": "static-3.86319",
  "crm_schema": "static-3.86356",
  "crm_universal": "static-1.20421",
  "crm-activity-creator-interaction-window": "static-1.40251",
  "crm-cards-dnd": "static-3.868",
  "crm-cards-global-registry": "static-1.14326",
  "crm-display-components": "static-1.19870",
  "crm-extension": "static-1.35827",
  "crm-legacy-links": "static-1.71205",
  "crm-meetings-components-lib": "static-1.21131",
  "crm-object-preview": "static-1.20914",
  "crm-source-interpretation-lib": "static-1.3950",
  "crm-ui-legacy-tracking-page-view": "static-1.67336",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.469",
  "customer-data-filters": "static-1.47121",
  "customer-data-objects-ui-components": "static-1.11560",
  "customer-data-properties": "static-1.45228",
  "customer-data-property-utils": "static-1.6606",
  "customer-data-reference-ui-components": "static-1.11657",
  "customer-data-rte": "static-1.28598",
  "customer-data-ui-utilities": "static-1.8407",
  "deal-registration-ui": "static-1.29691",
  "deal-splits-cards-ui": "static-1.39164",
  "deal-splits-sidebar": "static-1.39070",
  "draft-email-branding-plugin": "static-2.19866",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.19085",
  "draft-signature-plugin": "static-1.19629",
  "email-confirm-ui": "static-2.4311",
  "EmailSignatureEditor": "static-1.20209",
  "ExportDialog": "static-6.9072",
  "ExtensionInstallHelpers": "static-1.529",
  "file-manager-components": "static-1.17947",
  "FileManagerLib": "static-1.33588",
  "flywheel-feedback-panel-components": "static-1.5961",
  "foundations-assets": "static-1.3592",
  "foundations-theming": "static-1.2993",
  "framework-data-schema-resolvers": "static-1.5548",
  "hubspot-prosemirror": "static-1.13231",
  "HubStyle": "static-2.10485",
  "icons": "static-2.591",
  "in-meeting-experience-ui-components": "static-1.16619",
  "InboxConnectUtils": "static-4.9331",
  "integration-settings-components": "static-1.10219",
  "lead-tracking-lib": "static-1.33459",
  "metrics-js": "static-1.8417",
  "mobile-manifest-mixins": "static-1.338",
  "native-integrations-shared-strings": "static-1.6512",
  "nav-meta": "static-1.25232",
  "object-builder-ui-client": "static-1.41470",
  "partner-shared-view-ui": "static-1.41979",
  "playbooks-modal": "static-1.75034",
  "playlists-lib": "static-1.6524",
  "products-ui-components": "static-1.34942",
  "property-history-panel": "static-1.18999",
  "property-translator": "static-1.4067",
  "react-colorpicker": "static-2.8918",
  "react-immutable-proptypes": "static-2.8",
  "react-rhumb": "static-1.15266",
  "react-select-plus": "static-1.65",
  "reference-resolvers-lite": "static-1.6650",
  "reporting-action-components": "static-1.35724",
  "reporting-data": "static-1.61172",
  "reporting-enablement": "static-1.16542",
  "reporting-ui-components": "static-2.58450",
  "reporting-visualizations": "static-1.53249",
  "rich-text-lib": "static-1.17236",
  "rpc-client-utils": "static-1.3398",
  "SafeStorage": "static-1.3090",
  "SalesContentIndexUI": "static-3.6919",
  "sanitize-text": "static-1.6860",
  "segment-references-panel-lib": "static-1.49865",
  "sequences-crm-events-lib": "static-1.22639",
  "sequences-crm-lib": "static-1.22836",
  "settings-ui-nav": "static-2.8747",
  "SharedI18nStrings": "static-1.162",
  "styled-components": "static-2.63",
  "subscriptions-components": "static-1.40908",
  "timezone-utils": "static-2.3929",
  "transcript-sidebar": "static-1.62104",
  "transmute": "static-2.29",
  "ui-addon-form-validation": "static-1.9699",
  "ui-addon-i18n": "static-1-jm-full-name-input.5",
  "ui-addon-iframeable": "static-1.7569",
  "ui-addon-scriptloader": "static-1.11069",
  "ui-addon-teams": "static-1.19592",
  "ui-addon-upgrades": "static-9.15847",
  "ui-asset-management-lib": "static-1.8888",
  "ui-business-units-lib": "static-1.7552",
  "ui-extensions-remote-renderer": "static-1.12111",
  "ui-gdpr-components": "static-1.8928",
  "ui-product-approvals": "static-1.23515",
  "ui-shepherd-react": "static-3.8731",
  "ui-suspension-banners-lib": "static-1.5101",
  "usage-tracker-container": "static-1.6133",
  "atom": "static-1.3907",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-render-mixin": "static-1.9",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.43",
  "sanitize": "static-1.3064",
  "hs-promise-rejection-tracking": "static-1.4190",
  "raven-hubspot": "static-1.4953",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3028",
  "react-redux": "static-7.16",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.2344",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.1708",
  "quartz-webpack": "static-1.1655",
  "ably": "static-1.18",
  "hs-promise-utils": "static-1.4205",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.8357",
  "chatspot-core": "static-1.14987",
  "ContentUtils": "static-1.62723",
  "foundations-theming-base": "static-1.1978",
  "hs-story-utils": "static-1.8073",
  "sassPrefix": "static-1.130",
  "ui-fonts": "static-1.331",
  "ui-images": "static-2.809",
  "graphql": "static-1.58",
  "calling-client-interface": "static-1.69610",
  "calling-cross-tab-library": "static-1.17861",
  "calling-integration-cross-tab": "static-1.17040",
  "calling-integration-sdk-support": "static-1.25266",
  "calling-lifecycle-messages": "static-1.50748",
  "calling-lifecycle-usage-tracker": "static-1.4731",
  "calling-usage-tracker": "static-1.5173",
  "content-assistance-lib": "static-1.6160",
  "conversations-async-data": "static-2.6348",
  "conversations-prop-types": "static-1.6102",
  "conversations-skeleton-state": "static-1.6063",
  "customer-data-content": "static-1.24270",
  "immer": "static-1.33",
  "PatternValidationJS": "static-1.437",
  "self-service-api": "static-1.8869",
  "shared-worker-versioning": "static-1.9747",
  "frontend-preferences-client": "static-1.6553",
  "onboarding-scopes": "static-1.5235",
  "avatar-components": "static-1.1098",
  "campaigns-lib": "static-1.21729",
  "card-payment-highlight-lib": "static-1.31313",
  "commerce-subscription-cards-lib": "static-1.25583",
  "credit-memos-iframe-lib": "static-1.5803",
  "growth-payments-core": "static-1.20699",
  "payment-link-components": "static-1.18104",
  "payments-embed-points-lib": "static-1.9068",
  "persist-promise": "static-1.2427",
  "commerce-shared-components-lib": "static-1.14333",
  "draft-content-plugins": "static-1.23944",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "FireAlarmUi": "static-1.3531",
  "multi-account-crm-panel-lib": "static-1.11773",
  "react-virtualized": "static-2.73",
  "reselect": "static-2.16",
  "sequences-lib": "static-1.5742",
  "superstore": "static-1.3449",
  "ui-partner-confirmation-links-components": "static-1.21380",
  "enrichment-properties-lib": "static-1.9220",
  "inbound-db-properties-service-client": "static-1.2822",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1248",
  "crm-events-components": "static-1.55007",
  "hub-http-contrib": "static-1.1848",
  "prosemirror": "static-1.13",
  "react-dnd-compat": "static-1.3336",
  "task-forms-lib": "static-1.35529",
  "task-queues": "static-1.28303",
  "ui-addon-video-player": "static-1.7446",
  "location-customization-utils-lib": "static-1.3587",
  "crm-actions": "static-1.4738",
  "redux-toolkit": "static-1.7",
  "customer-data-sidebar-test-utils": "static-1.35146",
  "all-properties-panel-lib": "static-1.2287",
  "card-company-summary-lib": "static-1.13518",
  "card-engagement-attachments-lib": "static-1.67562",
  "card-integration-card-lib": "static-1.67575",
  "crm-events-viz-core": "static-1.28091",
  "crm-events-viz-timeline": "static-1.35755",
  "crm-record-access-management-lib": "static-1.20785",
  "customer-data-filters-ui": "static-1.33306",
  "customer-data-modals": "static-1.3472",
  "framework-scoring-history-panel-lib": "static-1.9940",
  "merge-modal-lib": "static-1.6311",
  "panel-deal-registration-ai-summary-lib": "static-1.22224",
  "predictive-scores-panel": "static-1.24344",
  "property-description-translator": "static-1.2531",
  "redux-mock-store": "static-1.8",
  "crm-index-visualization-object-layout": "static-1.33",
  "crm-object-search-query-utilities": "static-1.6021",
  "inbound-db-meta-service-client": "static-1.2678",
  "collaboration-sidebar": "static-1.51831",
  "outpost": "static-1.3027",
  "pipeline-validation-client-types": "static-1.2766",
  "user-context": "static-1.3850",
  "accounting-extension-card-ui": "static-1.30995",
  "ai-addon-copilot-preview": "static-1.4254",
  "analytics_js": "static-1.3235",
  "attribution-sidebar-cards": "static-1.38596",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17858",
  "crm-events": "static-1.55014",
  "feedback-schema": "static-1.48151",
  "FileManagerCore": "static-1.33447",
  "flux-actions": "static-1.268",
  "flywheel-lead-visibility-lib": "static-1.499",
  "forms-utils-lib": "static-1.10022",
  "FormsCommonComponents": "static-1.80562",
  "FormUrlGenerator": "static-2.3403",
  "getting-started-shared-tasks": "static-1.11768",
  "integrations-lib": "static-1.9966",
  "integrations-tracking-lib": "static-1.4171",
  "MeetingsBase": "static-1.54617",
  "partner-poi-timeline-event": "static-1.34570",
  "project-storage": "static-1.3369",
  "qualified-leads-embedded-lib": "static-1.42141",
  "quotes-crm-events-lib": "static-1.37101",
  "quotes-modal-lib": "static-1.95681",
  "react-table": "static-1.15",
  "report-customization-components": "static-1.8349",
  "reporting-snowflake": "static-1.49793",
  "salesforce-sync-card-ui": "static-1.7625",
  "salesImages": "static-1.498",
  "sequences-client-types-lib": "static-1.5598",
  "share-transcript-modal": "static-1.51749",
  "social-components-lib": "static-1.28502",
  "StyleGuideUI": "static-3.455",
  "svh-tickets-lib": "static-1.13279",
  "ui-addon-integrations-directory-panel": "static-2.6670",
  "ui-addon-react-router-dom": "static-1.8291",
  "ui-addon-sales-email": "static-1.3891",
  "ui-tour-react": "static-1.10651",
  "urlinator": "static-1.3231",
  "hubspot-prosemirror-plugins": "static-1.13223",
  "outreach-assistant-email-generation": "static-1.2547",
  "quotes-client-types": "static-1.31092",
  "sales-email-signature-service-client": "static-1.2668",
  "conditional-properties-service-client": "static-1.2813",
  "external-options-client-types": "static-1.2976",
  "inbounddb-objects-service-types": "static-1.3113",
  "card-subscription-highlight-lib": "static-1.33181",
  "invoices-highlight-card-lib": "static-1.49090",
  "orders-highlight-card-lib": "static-1.16795",
  "products-highlight-card-lib": "static-1.12707",
  "quotes-highlight-card-lib": "static-1.65013",
  "wootric-nps": "static-1.5630",
  "bend-plugin-foundations-components": "static-1.2122",
  "floating-ui": "static-1.28",
  "framer-motion": "static-1.40",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "crm-pipelines-api-client-types": "static-1.3027",
  "framework-builder-read-service-client": "static-1.2951",
  "customer-data-associations": "static-1.5880",
  "smart-property-lib": "static-1.100",
  "testing-library": "static-1.120",
  "HeadJS": "static-2.567",
  "hs-test-utils-bend-plugin": "static-1.1780",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.3020",
  "foundations-components-test-utils": "static-1.3339",
  "laboratory-lib": "static-3.5934",
  "react-transition-group": "static-1.7",
  "redux-actions": "static-3.7",
  "signup-constants": "static-1.15961",
  "signup-ui-lego-core": "static-1.17971",
  "signup-ui-url-generator": "static-2.6726",
  "underscore": "static-1.8",
  "usage-tracker-anonymous": "static-1.4560",
  "usage-tracker-multi": "static-1.4557",
  "usage-tracker-public": "static-1.5954",
  "viral-links-lib": "static-1.5557",
  "ts-schema": "static-1.3028",
  "growth-data-modal": "static-1.3889",
  "growth-onboarding-confetti": "static-1.1788",
  "navigation-components": "static-1.13595",
  "ui-shepherd-tracker": "static-1.6112",
  "ui-universal-auth": "static-1.7472",
  "quartz-core-utils": "static-1.2298",
  "hub-http-janus": "static-1.639",
  "hub-http-shared-msw-handlers": "static-1.6918",
  "hubspotter-http": "static-1.3482",
  "hubspotter-http-shared-msw-handlers": "static-1.6916",
  "platform-navigation-bootstrap": "static-1.11088",
  "csstype": "static-1.38",
  "call-summary": "static-1.31763",
  "object-comments-thread-lib": "static-1.5729",
  "reporting-client-types": "static-1.1796",
  "ui-coaching-tips": "static-1.22173",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9149",
  "rxjs": "static-5.10",
  "react-flip-move": "static-1.46",
  "subscription-experience-data-types": "static-1.10219",
  "crm-properties-list": "static-1.33145",
  "activity-history-lib": "static-1.1637",
  "assisted-buying-components": "static-1.5710",
  "bet-customer-success-shared-ui": "static-1.11794",
  "company-details-components": "static-1.4590",
  "company-details-service-types": "static-1.2608",
  "final-form": "static-1.39",
  "flywheel-recent-conversions-lib": "static-1.1307",
  "industries-core": "static-1.5447",
  "payment-method-components": "static-1.5224",
  "quote-checkout-common-lib": "static-1.9098",
  "quote-checkout-service-types": "static-1.2292",
  "conversations-calling-message": "static-1.54151",
  "crm-events-viz-test-utils": "static-1.16712",
  "calling-orchestration-schema": "static-1.29942",
  "onboarding-tours-client": "static-1.3181",
  "twilio-voice-sdk": "static-1.50",
  "worker-connection-library": "static-1.11358",
  "commerce-analytics-service-client": "static-1.2402",
  "cv-backend-services": "static-1.1110",
  "growth-onboarding-empty-states": "static-1.3854",
  "payments-enrollment-embed-lib": "static-1.17221",
  "payments-post-enroll-local-storage-lib": "static-1.3777",
  "qrcode-generator": "static-1.43",
  "conversations-infrastructure": "static-1.7612",
  "conversations-internal-schema": "static-1.11331",
  "conversations-error-reporting": "static-1.7626",
  "composer-data": "static-1.25192",
  "conversations-http": "static-1.3484",
  "conversations-internal-pub-sub": "static-1.14685",
  "conversations-platform": "static-1.3181",
  "conversations-thread-data": "static-1.62368",
  "ui-addon-conversations-settings": "static-2.27127",
  "zorse-crm-components-lib": "static-1.5683",
  "crm-activity-creator-interactions": "static-1.39523",
  "ui-addon-draggable-compat": "static-2.2943",
  "adobe-sign-cards-lib": "static-1.12771",
  "automation-ui-crm-card-workflows-invoker": "static-1.4803",
  "buyer-intent-card": "static-1.15869",
  "card-call-summaries-lib": "static-1.29893",
  "card-customer-spend-trends-lib": "static-1.20848",
  "card-flywheel-activity-history-lib": "static-1.1991",
  "card-flywheel-company-overview-lib": "static-1.11020",
  "card-flywheel-domain-review-history-lib": "static-1.648",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.11020",
  "card-guest-access-management-lib": "static-1.2581",
  "card-guided-execution-activities": "static-1.4018",
  "card-knowledge-base-lib": "static-1.6712",
  "card-lead-insights": "static-1.9251",
  "card-lead-qualification-lib": "static-1.24776",
  "card-object-highlight-lib": "static-1.1313",
  "card-object-summary-lib": "static-1.2812",
  "card-other-tickets-lib": "static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.25696",
  "card-partner-client-unified-usage-score-lib": "static-1.20061",
  "card-prospecting-research-agent": "static-1.2139",
  "card-target-account-signals": "static-1.688",
  "card-tasks-timeline-lib": "static-1.9577",
  "card-ticket-summary-lib": "static-1.11424",
  "commerce-billing-engine-lib": "static-1.1125",
  "crm-associations-pivot": "static-1.34099",
  "crm-associations-table": "static-1.35969",
  "crm-clv-report": "static-1.2757",
  "crm-data-highlights": "static-1.36507",
  "crm-events-viz-cards": "static-1.35747",
  "crm-events-viz-totals": "static-1.27300",
  "crm-property-history": "static-1.11205",
  "crm-quick-actions": "static-1.12655",
  "crm-relative-timeline": "static-1.13083",
  "crm-report": "static-1.36714",
  "crm-simple-deadline": "static-1.13301",
  "crm-stage-tracker": "static-1.31678",
  "crm-statistics": "static-1.25723",
  "custom-events-card-lib": "static-1.373",
  "customer-overview-card-lib": "static-1.4338",
  "customer-success-contacts-card-lib": "static-1.12565",
  "deal-summary-components": "static-1.15404",
  "docusign-cards-lib": "static-1.22211",
  "flywheel-growth-plans-crm-card": "static-1.1563",
  "guided-actions-card": "static-1.9007",
  "guided-selling-stage-tracker-card": "static-1.6247",
  "health-score-card-lib": "static-1.15848",
  "help-desk-insights-lib-crm-cards": "static-1.17750",
  "intelligence-overview-card": "static-1.9701",
  "intelligence-overview-lib": "static-1.7887",
  "invoices-history-card-lib": "static-1.25518",
  "lead-scores-card": "static-1.12172",
  "legacy-sidebar-card-lib": "static-1.29386",
  "payment-schedule-card-lib": "static-1.22969",
  "playbooks-card": "static-1.37744",
  "predictive-scores-card": "static-1.25342",
  "process-guide-cards": "static-1.3450",
  "products-cards-lib": "static-1.4015",
  "purchase-history-lib": "static-1.15198",
  "ui-google-drive-attachments": "static-1.1471",
  "ui-google-drive-insights": "static-1.1473",
  "crm-component-utils": "static-1.34120",
  "content-embed-lib": "static-1.6026",
  "remote-ui": "static-1.39",
  "ui-extensions": "static-1.14518",
  "ui-extensions-plugin-flywheel": "static-1.9052",
  "credit-memos-highlight-card-lib": "static-1.5156",
  "deep-diff": "static-1.5",
  "commerce-products-lib": "static-1.4422",
  "google-libphonenumber": "static-1.11",
  "media-bridge-lib": "static-1.16507",
  "video-data-lib": "static-1.28962",
  "FileManagerImages": "static-1.31098",
  "bend-plugin-foundations-theming": "static-1.1476",
  "fast-json-stable-stringify": "static-1.4",
  "knowledge-content-types": "static-1.7633",
  "ui-addon-emoji-picker": "static-1.8617",
  "card-playbooks-lib": "static-1.57861",
  "in-meeting-experience-client-types": "static-1.13319",
  "marketplace-embed": "static-1.15950",
  "crm-record-cards-service-types": "static-1.2672",
  "ui-components-test-utils": "static-1.4315",
  "universal-page-editor-lib": "static-1.1618",
  "card-sales-activities-timeline": "static-1.32563",
  "partner-shared-messages-lib": "static-1.12775",
  "dashboard-lib": "static-1.75269",
  "share-with-third-party-component-lib": "static-1.7343",
  "data-quality-ui-library": "static-1.7555",
  "html-to-image": "static-1.29",
  "reporting-plugins": "static-1.6548",
  "reporting-reports": "static-1.60856",
  "data-token-picker": "static-1.13916",
  "account-and-billing-components": "static-1.16219",
  "growth-feature-usage-components": "static-1.4246",
  "subscriptions-client": "static-1.41148",
  "magpie-lib": "static-1.4350",
  "navigation-messaging": "static-1.2922",
  "feature-store-service-types": "static-1.3360",
  "growth-monetization-service-types": "static-1.3367",
  "upgrade-management-service-types": "static-1.3351",
  "ui-extensibility-client-types": "static-1.2859",
  "cms-field-types": "static-1.3469",
  "content-icons-ui": "static-1.1867",
  "attribution-lib": "static-1.37115",
  "campaigns-build-lib": "static-1.7233",
  "marketing-platform-lib": "static-1.5350",
  "credit-memos-ui-lib": "static-1.5801",
  "commerce-tours-lib": "static-1.3233",
  "growth-onboarding-reliability": "static-1.3838",
  "sales-checkout-service-client": "static-1.2414",
  "breeze-intelligence-kit": "static-1.3885",
  "fsm": "static-1.2387",
  "policy-lib": "static-1.5469",
  "amplitude-session-replay-browser": "static-1.6",
  "flywheel-reject-ql-lib": "static-1.1328",
  "customer-data-filters-ui-msw-helpers": "static-1.15739",
  "automation-ui-core": "static-2.15379",
  "automation-ui-permissions": "static-1.13741",
  "framework-scoring-client-types": "static-1.10993",
  "markdown-it": "static-1.6",
  "predictive-scores-lib-components": "static-1.22739",
  "getting-started-shared-tasks-store": "static-1.10886",
  "ai-settings-ui-library": "static-1.5755",
  "crm-pipeline-events-ui": "static-1.22203",
  "audio-components": "static-1.4310",
  "video-components": "static-1.7314",
  "video-embed": "static-1.29803",
  "portal-details-components": "static-1.13578",
  "forms-ai-lib": "static-1.2092",
  "react-tinymce": "static-1.50120",
  "SharedLegalStrings": "static-1.1300",
  "tinymce-config": "static-2.49246",
  "integrations-error-boundary-lib": "static-1.7381",
  "meetings-client-types": "static-1.2680",
  "reporting-datasets-permissions-lib": "static-1.6923",
  "growth-onboarding-feedback-components": "static-1.5131",
  "messaging-types-lib": "static-1.39828",
  "accounting-integrations-ui-components": "static-1.4676",
  "invoices-iframe-lib": "static-1.51163",
  "invoices-ui-lib": "static-1.49105",
  "products-iframe-lib": "static-1.2487",
  "products-ui-components-shared-msw-handlers": "static-1.7303",
  "emoji-regex": "static-1.7",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3811",
  "simple-logging-lib": "static-1.1715",
  "platform-infra-nav-components": "static-1.6587",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7064",
  "fintech-buying-service-clients": "static-1.2375",
  "account-and-billing-contacts-usage": "static-2.17677",
  "signup-ui-full-screen-search": "static-1.10064",
  "billing-payments-client-types": "static-1.2746",
  "buying-experience-components": "static-1.8484",
  "checkout-service-types": "static-1.2830",
  "growth-pro-utils-lib": "static-1.7868",
  "trellis-story-utils": "static-1.3233",
  "marketplace-ui-apps-core": "static-1.12193",
  "stripe-embedded-components": "static-1.5027",
  "conversations-routing-lib": "static-1.5795",
  "immutable-less": "static-1.3239",
  "routing-ui": "static-1.15492",
  "conversations-visibility-tools": "static-1.4433",
  "data-ops-fullstory": "static-1.4023",
  "re-reselect": "static-1.4",
  "automation-enrollment-service-types": "static-1.2611",
  "automation-platform-service-types": "static-1.2098",
  "domain-review-history-lib": "static-1.1716",
  "renewal-center-service-types": "static-1.2847",
  "recent-activities-card": "static-1.52871",
  "submissions-lib": "static-1.41089",
  "ui-forms-components": "static-1.8017",
  "prospecting-agent-lib": "static-1.6516",
  "customer-success-client-types": "static-1.14261",
  "sales-enablement-lib": "static-1.11472",
  "sales-leader-insights-components-lib": "static-1.13078",
  "guided-actions-lib": "static-1.14287",
  "property-management-iframe": "static-1.7858",
  "card-bet-associated-companies-lib": "static-1.71292",
  "card-bet-deal-support-requests-lib": "static-1.62033",
  "card-bet-quotes-lib": "static-1.71299",
  "card-biz-ops-customer-success-lib": "static-1.71313",
  "card-biz-ops-domain-controls-lib": "static-1.71314",
  "card-biz-ops-related-contacts-lib": "static-1.71313",
  "card-crm-attribution-lib": "static-1.49567",
  "card-deal-shared-view-lib": "static-1.63288",
  "card-deal-splits-lib": "static-1.38550",
  "card-flywheel-ql-summary-lib": "static-1.40179",
  "card-flywheel-recent-conversions-lib": "static-1.40180",
  "card-gdpr-subscriptions-card-lib": "static-1.41610",
  "card-invoices-lib": "static-1.50695",
  "card-lists-lib": "static-1.65628",
  "card-marketing-event-about-lib": "static-1.50477",
  "card-marketing-event-activity-lib": "static-1.50476",
  "card-past-conversations-lib": "static-1.31981",
  "card-past-feedback-lib": "static-1.36295",
  "card-payment-history-lib": "static-1.31178",
  "card-profile-products-lib": "static-1.51357",
  "card-profile-quotes-lib": "static-1.78532",
  "card-prospecting-notes": "static-1.32563",
  "card-qualified-leads-lib": "static-1.71454",
  "card-sfdcsync-lib": "static-1.50547",
  "card-target-account-lib": "static-1.67287",
  "card-website-activity-lib": "static-1.68093",
  "card-workflows-lib": "static-1.67464",
  "integrations-sync-card-ui": "static-1.21488",
  "invoices-card-lib": "static-1.51234",
  "marketing-event-cards-ui": "static-1.31413",
  "orders-card-lib": "static-1.16512",
  "partner-poi-crm-card": "static-1.14025",
  "recording-preview-card": "static-1.11398",
  "surveymonkey-crm-card": "static-1.35120",
  "ui-sales-order-wizard-card": "static-1.26477",
  "sales-execution-components": "static-1.7762",
  "process-guide-chirp": "static-1.3282",
  "gapi-client-types": "static-1.3",
  "google-picker-types": "static-1.3",
  "ui-google-drive-picker": "static-1.1042",
  "marketplace-ui-client-types": "static-1.11063",
  "marketplace-ui-common": "static-1.13657",
  "marketplace-ui-details": "static-1.3557",
  "trellis-ecosystem": "static-1.4388",
  "campaign-roi-lib": "static-1.2375",
  "account-and-billing-fintech-outages": "static-3.14969",
  "fintech-outages-service-client-types": "static-1.11845",
  "transactions-exp-service-client-types": "static-1.11841",
  "growth-feature-usage-data": "static-1.4465",
  "automation-ui-routing": "static-1.14803",
  "automation-ui-source-apps": "static-1.12525",
  "immerable": "static-1.2836",
  "social-insights-client-types": "static-1.17407",
  "user-configuration-lib": "static-1.24203",
  "tinymce-themes": "static-1.51216",
  "interframe": "static-3.3482",
  "tinymce-data": "static-1.35331",
  "tinymce-plugins": "static-1.52360",
  "ContentData": "static-1.62799",
  "marketing-email-service-types": "static-1.1418",
  "sales-views-client-types": "static-1.3026",
  "ui-signature-editor": "static-1.13384",
  "developer-experience-shared-components": "static-1.8768",
  "stripe-connect-js": "static-1.39",
  "form-builder-ui": "static-1.7773",
  "ui-deal-management-components-lib": "static-1.15303",
  "property-management-common": "static-1.144",
  "react-window": "static-1.13",
  "embedded-academy-lib": "static-1.9820",
  "marketplace-ui-reviews": "static-1.13616",
  "marketplace-ui-tracking": "static-1.7831",
  "app-users-service-client": "static-1.3731",
  "app-users-service-types": "static-1.3137",
  "framework-listing-lib": "static-2.21950",
  "mini-checkout-client": "static-1.23934",
  "onboarding-utils": "static-1.4038",
  "ui-coaching-tips-shared-config": "static-1.22158",
  "NamespacedHubStyle": "static-2.8122",
  "codemirror": "static-5.69",
  "layout-dnd-components": "static-1.10610",
  "layout-dnd-utils": "static-1.9585",
  "react-codemirror": "static-1.9290",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2973",
  "academy-common-lib": "static-1.9280",
  "customer-data-views-management": "static-1.21900",
  "framework-listing-lib-shared-msw-handlers": "static-1.6809",
  "touchless-buying-components": "static-1.3138",
  "merchandise-lib": "static-1.223",
  "settings-content-modals": "static-1.39470",
  "diff-match-patch": "static-1.7",
  "layout-data-lib": "static-1.7910",
  "browser-eslint": "static-2.57",
  "academy-service-client": "static-1.2688",
  "zustand": "static-1.51",
  "crm-export-dialog": "static-1.4977",
  "crm-index-associations-lib": "static-1.5059",
  "react-beautiful-dnd": "static-1.13",
  "checkout-sdk": "static-3.20777",
  "upgrade-catalog-service-types": "static-1.2561",
  "access-control-lib": "static-1.9136",
  "EmailComponents": "static-1.48523",
  "EmailData": "static-1.47199",
  "redux-less": "static-2.8124",
  "hub-http-rxjs": "static-1.606",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "ContentComponents": "static-2.65680",
  "marketing-contacts-lib": "static-1.7821",
  "messaging-editing-lib": "static-1.40092",
  "ui-tool-access": "static-1.8737",
  "automation-ui-types": "static-1.13443",
  "data-token-views": "static-1.13897",
  "simple-menus-core": "static-1.13416",
  "simple-menus-lib": "static-1.14933",
  "ui-memberships-settings-lib": "static-1.27890",
  "videoconference-integration-components": "static-1.4803",
  "automation-applications-service-types": "static-1.2462",
  "ContentEditorUI": "static-2.71140",
  "short-messages-app-service-client": "static-1.2826",
  "web-interactives-components": "static-1.11312",
  "web-interactives-data": "static-1.11313",
  "seamless-immutable": "static-7.6",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3744",
  "copilot-plugins": "static-1.5761",
  "cta-picker": "static-1.30901",
  "editor-components": "static-1.11694",
  "editor-iframe-lib": "static-1.6991",
  "error-messaging-js": "static-1.3975",
  "pictos": "static-7.159",
  "redux-request-state": "static-1.9263",
  "smart-content-core": "static-1.36856",
  "smart-content-lib": "static-1.37509",
  "social-composer-lib": "static-1.52930",
  "structured-content-lib": "static-1.19769",
  "theme-previewer-lib": "static-1.47471",
  "tinymce-copilot": "static-1.11314",
  "ui-active-theme-content-creator-lib": "static-1.31377",
  "xray-recommendation-lib": "static-1.5777",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.4586",
  "ui-brand-identity-lib": "static-1.8050",
  "fuzzy": "static-1.8",
  "codemirror-dlb": "static-1.52695",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-records-ui": "/crm-records-ui/static-1.77261",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5042",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3467",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3187",
  "call-widget-addon": "/call-widget-addon/static-2.27178",
  "calling-global-api": "/calling-global-api/static-1.57070",
  "calling-internal-common": "/calling-internal-common/static-1.29895",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.58452",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.38249",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.5876",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.35289",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.69852",
  "card-properties-lib": "/card-properties-lib/static-1.38342",
  "client-types": "/client-types/static-1.372",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5656",
  "copilot-toolkit": "/copilot-toolkit/static-1.5788",
  "crm_data": "/crm_data/static-4.86319",
  "crm_ui": "/crm_ui/static-5.86277",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.40798",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.30720",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.46302",
  "crm-cards": "/crm-cards/static-1.38888",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37591",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.37438",
  "crm-command-handler": "/crm-command-handler/static-1.30241",
  "crm-common-dlb": "/crm-common-dlb/static-1.3997",
  "crm-events-data": "/crm-events-data/static-1.55020",
  "crm-fe-perf": "/crm-fe-perf/static-1.21679",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22463",
  "crm-links": "/crm-links/static-1.4774",
  "crm-message-bus": "/crm-message-bus/static-1.36173",
  "crm-object-map": "/crm-object-map/static-1.1659",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.18773",
  "crm-timeline": "/crm-timeline/static-1.83346",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.32243",
  "customer-data-communicator": "/customer-data-communicator/static-1.39765",
  "customer-data-email": "/customer-data-email/static-1.15596",
  "customer-data-objects": "/customer-data-objects/static-1.6287",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6248",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.40468",
  "customer-data-tracking": "/customer-data-tracking/static-1.5478",
  "data-fetching-client": "/data-fetching-client/static-1.8302",
  "dispatcher": "/dispatcher/static-1.111",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.300",
  "feedback-loader": "/feedback-loader/static-1.26336",
  "foundations-components": "/foundations-components/static-1.5854",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.710",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5453",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7004",
  "framework-data-table": "/framework-data-table/static-2.8364",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.3911",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6669",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3506",
  "hubspot-dlb": "/hubspot-dlb/static-2.1371",
  "HubStyleTokens": "/HubStyleTokens/static-2.10176",
  "I18n": "/I18n/static-7.1380",
  "immutable": "/immutable/static-2.19",
  "jasmine-console-invariants": "/jasmine-console-invariants/static-1.1394",
  "jasmine-immutable": "/jasmine-immutable/static-1.1646",
  "jasmine-runner": "/jasmine-runner/static-1.5083",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.4805",
  "MeetingsLib": "/MeetingsLib/static-2.53025",
  "msw": "/msw/static-1.39",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2729",
  "onboarding-tours": "/onboarding-tours/static-1.14025",
  "PortalIdParser": "/PortalIdParser/static-2.278",
  "quartz": "/quartz/static-1.5431",
  "quartz-core": "/quartz-core/static-1.4650",
  "quick-fetch": "/quick-fetch/static-1.2875",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.73724",
  "raven": "/raven/static-3.4646",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.51",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-dom": "/react-dom/static-7.85",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4217",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.26049",
  "reference-resolvers": "/reference-resolvers/static-1.6833",
  "reporting-dlb": "/reporting-dlb/static-1.54090",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.3107",
  "sales-clients-common": "/sales-clients-common/static-1.45155",
  "settings-ui-lib": "/settings-ui-lib/static-1.11237",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8111",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1197",
  "ui-addon-opt": "/ui-addon-opt/static-4.7337",
  "UIComponents": "/UIComponents/static-3.7124",
  "universal-associations-select": "/universal-associations-select/static-1.9467",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.3184",
  "usage-tracker": "/usage-tracker/static-1.6143",
  "usage-tracker-core": "/usage-tracker-core/static-1.5993",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-catchup-cards-lib": "/ai-catchup-cards-lib/static-1.2195",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.40180",
  "call-timeline-event": "/call-timeline-event/static-1.50373",
  "calling-error-reporting": "/calling-error-reporting/static-1.29901",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.12966",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.29717",
  "calling-ui-library": "/calling-ui-library/static-1.64371",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.32370",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14981",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14292",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30758",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.6149",
  "composer-plugins": "/composer-plugins/static-1.66367",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.29421",
  "conversations-message-history": "/conversations-message-history/static-1.9772",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.29032",
  "crm_components": "/crm_components/static-3.86319",
  "crm_schema": "/crm_schema/static-3.86356",
  "crm_universal": "/crm_universal/static-1.20421",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.40251",
  "crm-cards-dnd": "/crm-cards-dnd/static-3.868",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.14326",
  "crm-display-components": "/crm-display-components/static-1.19870",
  "crm-extension": "/crm-extension/static-1.35827",
  "crm-legacy-links": "/crm-legacy-links/static-1.71205",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.21131",
  "crm-object-preview": "/crm-object-preview/static-1.20914",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3950",
  "crm-ui-legacy-tracking-page-view": "/crm-ui-legacy-tracking-page-view/static-1.67336",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.469",
  "customer-data-filters": "/customer-data-filters/static-1.47121",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11560",
  "customer-data-properties": "/customer-data-properties/static-1.45228",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6606",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11657",
  "customer-data-rte": "/customer-data-rte/static-1.28598",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8407",
  "deal-registration-ui": "/deal-registration-ui/static-1.29691",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.39164",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.39070",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.19866",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.19085",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.19629",
  "email-confirm-ui": "/email-confirm-ui/static-2.4311",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20209",
  "ExportDialog": "/ExportDialog/static-6.9072",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.529",
  "file-manager-components": "/file-manager-components/static-1.17947",
  "FileManagerLib": "/FileManagerLib/static-1.33588",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5961",
  "foundations-assets": "/foundations-assets/static-1.3592",
  "foundations-theming": "/foundations-theming/static-1.2993",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5548",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13231",
  "HubStyle": "/HubStyle/static-2.10485",
  "icons": "/icons/static-2.591",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.16619",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9331",
  "integration-settings-components": "/integration-settings-components/static-1.10219",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.33459",
  "metrics-js": "/metrics-js/static-1.8417",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.338",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6512",
  "nav-meta": "/nav-meta/static-1.25232",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41470",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.41979",
  "playbooks-modal": "/playbooks-modal/static-1.75034",
  "playlists-lib": "/playlists-lib/static-1.6524",
  "products-ui-components": "/products-ui-components/static-1.34942",
  "property-history-panel": "/property-history-panel/static-1.18999",
  "property-translator": "/property-translator/static-1.4067",
  "react-colorpicker": "/react-colorpicker/static-2.8918",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-rhumb": "/react-rhumb/static-1.15266",
  "react-select-plus": "/react-select-plus/static-1.65",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6650",
  "reporting-action-components": "/reporting-action-components/static-1.35724",
  "reporting-data": "/reporting-data/static-1.61172",
  "reporting-enablement": "/reporting-enablement/static-1.16542",
  "reporting-ui-components": "/reporting-ui-components/static-2.58450",
  "reporting-visualizations": "/reporting-visualizations/static-1.53249",
  "rich-text-lib": "/rich-text-lib/static-1.17236",
  "rpc-client-utils": "/rpc-client-utils/static-1.3398",
  "SafeStorage": "/SafeStorage/static-1.3090",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6919",
  "sanitize-text": "/sanitize-text/static-1.6860",
  "segment-references-panel-lib": "/segment-references-panel-lib/static-1.49865",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.22639",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.22836",
  "settings-ui-nav": "/settings-ui-nav/static-2.8747",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "styled-components": "/styled-components/static-2.63",
  "subscriptions-components": "/subscriptions-components/static-1.40908",
  "timezone-utils": "/timezone-utils/static-2.3929",
  "transcript-sidebar": "/transcript-sidebar/static-1.62104",
  "transmute": "/transmute/static-2.29",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9699",
  "ui-addon-i18n": "/ui-addon-i18n/static-1-jm-full-name-input.5",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7569",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11069",
  "ui-addon-teams": "/ui-addon-teams/static-1.19592",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15847",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8888",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7552",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.12111",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8928",
  "ui-product-approvals": "/ui-product-approvals/static-1.23515",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8731",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5101",
  "usage-tracker-container": "/usage-tracker-container/static-1.6133",
  "atom": "/atom/static-1.3907",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sanitize": "/sanitize/static-1.3064",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4190",
  "raven-hubspot": "/raven-hubspot/static-1.4953",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3028",
  "react-redux": "/react-redux/static-7.16",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2344",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1708",
  "quartz-webpack": "/quartz-webpack/static-1.1655",
  "ably": "/ably/static-1.18",
  "hs-promise-utils": "/hs-promise-utils/static-1.4205",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.8357",
  "chatspot-core": "/chatspot-core/static-1.14987",
  "ContentUtils": "/ContentUtils/static-1.62723",
  "foundations-theming-base": "/foundations-theming-base/static-1.1978",
  "hs-story-utils": "/hs-story-utils/static-1.8073",
  "sassPrefix": "/sassPrefix/static-1.130",
  "ui-fonts": "/ui-fonts/static-1.331",
  "ui-images": "/ui-images/static-2.809",
  "graphql": "/graphql/static-1.58",
  "calling-client-interface": "/calling-client-interface/static-1.69610",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17861",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.17040",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.25266",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.50748",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4731",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5173",
  "content-assistance-lib": "/content-assistance-lib/static-1.6160",
  "conversations-async-data": "/conversations-async-data/static-2.6348",
  "conversations-prop-types": "/conversations-prop-types/static-1.6102",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6063",
  "customer-data-content": "/customer-data-content/static-1.24270",
  "immer": "/immer/static-1.33",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "self-service-api": "/self-service-api/static-1.8869",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9747",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6553",
  "onboarding-scopes": "/onboarding-scopes/static-1.5235",
  "avatar-components": "/avatar-components/static-1.1098",
  "campaigns-lib": "/campaigns-lib/static-1.21729",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.31313",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.25583",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.5803",
  "growth-payments-core": "/growth-payments-core/static-1.20699",
  "payment-link-components": "/payment-link-components/static-1.18104",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9068",
  "persist-promise": "/persist-promise/static-1.2427",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14333",
  "draft-content-plugins": "/draft-content-plugins/static-1.23944",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "FireAlarmUi": "/FireAlarmUi/static-1.3531",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.11773",
  "react-virtualized": "/react-virtualized/static-2.73",
  "reselect": "/reselect/static-2.16",
  "sequences-lib": "/sequences-lib/static-1.5742",
  "superstore": "/superstore/static-1.3449",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.21380",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.9220",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2822",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1248",
  "crm-events-components": "/crm-events-components/static-1.55007",
  "hub-http-contrib": "/hub-http-contrib/static-1.1848",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd-compat": "/react-dnd-compat/static-1.3336",
  "task-forms-lib": "/task-forms-lib/static-1.35529",
  "task-queues": "/task-queues/static-1.28303",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7446",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3587",
  "crm-actions": "/crm-actions/static-1.4738",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.35146",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.2287",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.13518",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.67562",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.67575",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.28091",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.35755",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.20785",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33306",
  "customer-data-modals": "/customer-data-modals/static-1.3472",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.9940",
  "merge-modal-lib": "/merge-modal-lib/static-1.6311",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.22224",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.24344",
  "property-description-translator": "/property-description-translator/static-1.2531",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.33",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6021",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2678",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51831",
  "outpost": "/outpost/static-1.3027",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2766",
  "user-context": "/user-context/static-1.3850",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.30995",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4254",
  "analytics_js": "/analytics_js/static-1.3235",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.38596",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17858",
  "crm-events": "/crm-events/static-1.55014",
  "feedback-schema": "/feedback-schema/static-1.48151",
  "FileManagerCore": "/FileManagerCore/static-1.33447",
  "flux-actions": "/flux-actions/static-1.268",
  "flywheel-lead-visibility-lib": "/flywheel-lead-visibility-lib/static-1.499",
  "forms-utils-lib": "/forms-utils-lib/static-1.10022",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.80562",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3403",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11768",
  "integrations-lib": "/integrations-lib/static-1.9966",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4171",
  "MeetingsBase": "/MeetingsBase/static-1.54617",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.34570",
  "project-storage": "/project-storage/static-1.3369",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.42141",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.37101",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.95681",
  "react-table": "/react-table/static-1.15",
  "report-customization-components": "/report-customization-components/static-1.8349",
  "reporting-snowflake": "/reporting-snowflake/static-1.49793",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7625",
  "salesImages": "/salesImages/static-1.498",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5598",
  "share-transcript-modal": "/share-transcript-modal/static-1.51749",
  "social-components-lib": "/social-components-lib/static-1.28502",
  "StyleGuideUI": "/StyleGuideUI/static-3.455",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.13279",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6670",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8291",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3891",
  "ui-tour-react": "/ui-tour-react/static-1.10651",
  "urlinator": "/urlinator/static-1.3231",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13223",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.2547",
  "quotes-client-types": "/quotes-client-types/static-1.31092",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2668",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2813",
  "external-options-client-types": "/external-options-client-types/static-1.2976",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3113",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.33181",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.49090",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.16795",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.12707",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.65013",
  "wootric-nps": "/wootric-nps/static-1.5630",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2122",
  "floating-ui": "/floating-ui/static-1.28",
  "framer-motion": "/framer-motion/static-1.40",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3027",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2951",
  "customer-data-associations": "/customer-data-associations/static-1.5880",
  "smart-property-lib": "/smart-property-lib/static-1.100",
  "testing-library": "/testing-library/static-1.120",
  "HeadJS": "/HeadJS/static-2.567",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1780",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.3020",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3339",
  "laboratory-lib": "/laboratory-lib/static-3.5934",
  "react-transition-group": "/react-transition-group/static-1.7",
  "redux-actions": "/redux-actions/static-3.7",
  "signup-constants": "/signup-constants/static-1.15961",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.17971",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6726",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4560",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4557",
  "usage-tracker-public": "/usage-tracker-public/static-1.5954",
  "viral-links-lib": "/viral-links-lib/static-1.5557",
  "ts-schema": "/ts-schema/static-1.3028",
  "growth-data-modal": "/growth-data-modal/static-1.3889",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1788",
  "navigation-components": "/navigation-components/static-1.13595",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6112",
  "ui-universal-auth": "/ui-universal-auth/static-1.7472",
  "quartz-core-utils": "/quartz-core-utils/static-1.2298",
  "hub-http-janus": "/hub-http-janus/static-1.639",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6918",
  "hubspotter-http": "/hubspotter-http/static-1.3482",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6916",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11088",
  "csstype": "/csstype/static-1.38",
  "call-summary": "/call-summary/static-1.31763",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.5729",
  "reporting-client-types": "/reporting-client-types/static-1.1796",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.22173",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9149",
  "rxjs": "/rxjs/static-5.10",
  "react-flip-move": "/react-flip-move/static-1.46",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10219",
  "crm-properties-list": "/crm-properties-list/static-1.33145",
  "activity-history-lib": "/activity-history-lib/static-1.1637",
  "assisted-buying-components": "/assisted-buying-components/static-1.5710",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.11794",
  "company-details-components": "/company-details-components/static-1.4590",
  "company-details-service-types": "/company-details-service-types/static-1.2608",
  "final-form": "/final-form/static-1.39",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.1307",
  "industries-core": "/industries-core/static-1.5447",
  "payment-method-components": "/payment-method-components/static-1.5224",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.9098",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2292",
  "conversations-calling-message": "/conversations-calling-message/static-1.54151",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.16712",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.29942",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3181",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.50",
  "worker-connection-library": "/worker-connection-library/static-1.11358",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "cv-backend-services": "/cv-backend-services/static-1.1110",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3854",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17221",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3777",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7612",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11331",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7626",
  "composer-data": "/composer-data/static-1.25192",
  "conversations-http": "/conversations-http/static-1.3484",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14685",
  "conversations-platform": "/conversations-platform/static-1.3181",
  "conversations-thread-data": "/conversations-thread-data/static-1.62368",
  "ui-addon-conversations-settings": "/ui-addon-conversations-settings/static-2.27127",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5683",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.39523",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.2943",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.12771",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.4803",
  "buyer-intent-card": "/buyer-intent-card/static-1.15869",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.29893",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.20848",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.1991",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.11020",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.648",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.11020",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.2581",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.4018",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6712",
  "card-lead-insights": "/card-lead-insights/static-1.9251",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.24776",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.1313",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2812",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.14987",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.25696",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.20061",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.2139",
  "card-target-account-signals": "/card-target-account-signals/static-1.688",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9577",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11424",
  "commerce-billing-engine-lib": "/commerce-billing-engine-lib/static-1.1125",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.34099",
  "crm-associations-table": "/crm-associations-table/static-1.35969",
  "crm-clv-report": "/crm-clv-report/static-1.2757",
  "crm-data-highlights": "/crm-data-highlights/static-1.36507",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.35747",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.27300",
  "crm-property-history": "/crm-property-history/static-1.11205",
  "crm-quick-actions": "/crm-quick-actions/static-1.12655",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.13083",
  "crm-report": "/crm-report/static-1.36714",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.13301",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.31678",
  "crm-statistics": "/crm-statistics/static-1.25723",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.373",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.4338",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.12565",
  "deal-summary-components": "/deal-summary-components/static-1.15404",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.22211",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.1563",
  "guided-actions-card": "/guided-actions-card/static-1.9007",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.6247",
  "health-score-card-lib": "/health-score-card-lib/static-1.15848",
  "help-desk-insights-lib-crm-cards": "/help-desk-insights-lib-crm-cards/static-1.17750",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.9701",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.7887",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.25518",
  "lead-scores-card": "/lead-scores-card/static-1.12172",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.29386",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.22969",
  "playbooks-card": "/playbooks-card/static-1.37744",
  "predictive-scores-card": "/predictive-scores-card/static-1.25342",
  "process-guide-cards": "/process-guide-cards/static-1.3450",
  "products-cards-lib": "/products-cards-lib/static-1.4015",
  "purchase-history-lib": "/purchase-history-lib/static-1.15198",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.1471",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.1473",
  "crm-component-utils": "/crm-component-utils/static-1.34120",
  "content-embed-lib": "/content-embed-lib/static-1.6026",
  "remote-ui": "/remote-ui/static-1.39",
  "ui-extensions": "/ui-extensions/static-1.14518",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.9052",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.5156",
  "deep-diff": "/deep-diff/static-1.5",
  "commerce-products-lib": "/commerce-products-lib/static-1.4422",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "media-bridge-lib": "/media-bridge-lib/static-1.16507",
  "video-data-lib": "/video-data-lib/static-1.28962",
  "FileManagerImages": "/FileManagerImages/static-1.31098",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1476",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.7633",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8617",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.57861",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.13319",
  "marketplace-embed": "/marketplace-embed/static-1.15950",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2672",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4315",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1618",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.32563",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.12775",
  "dashboard-lib": "/dashboard-lib/static-1.75269",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7343",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7555",
  "html-to-image": "/html-to-image/static-1.29",
  "reporting-plugins": "/reporting-plugins/static-1.6548",
  "reporting-reports": "/reporting-reports/static-1.60856",
  "data-token-picker": "/data-token-picker/static-1.13916",
  "account-and-billing-components": "/account-and-billing-components/static-1.16219",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4246",
  "subscriptions-client": "/subscriptions-client/static-1.41148",
  "magpie-lib": "/magpie-lib/static-1.4350",
  "navigation-messaging": "/navigation-messaging/static-1.2922",
  "feature-store-service-types": "/feature-store-service-types/static-1.3360",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3367",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3351",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2859",
  "cms-field-types": "/cms-field-types/static-1.3469",
  "content-icons-ui": "/content-icons-ui/static-1.1867",
  "attribution-lib": "/attribution-lib/static-1.37115",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.7233",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5350",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.5801",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3233",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3838",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3885",
  "fsm": "/fsm/static-1.2387",
  "policy-lib": "/policy-lib/static-1.5469",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.1328",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15739",
  "automation-ui-core": "/automation-ui-core/static-2.15379",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13741",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.10993",
  "markdown-it": "/markdown-it/static-1.6",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.22739",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10886",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5755",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.22203",
  "audio-components": "/audio-components/static-1.4310",
  "video-components": "/video-components/static-1.7314",
  "video-embed": "/video-embed/static-1.29803",
  "portal-details-components": "/portal-details-components/static-1.13578",
  "forms-ai-lib": "/forms-ai-lib/static-1.2092",
  "react-tinymce": "/react-tinymce/static-1.50120",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1300",
  "tinymce-config": "/tinymce-config/static-2.49246",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7381",
  "meetings-client-types": "/meetings-client-types/static-1.2680",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6923",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5131",
  "messaging-types-lib": "/messaging-types-lib/static-1.39828",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4676",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.51163",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.49105",
  "products-iframe-lib": "/products-iframe-lib/static-1.2487",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7303",
  "emoji-regex": "/emoji-regex/static-1.7",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3811",
  "simple-logging-lib": "/simple-logging-lib/static-1.1715",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6587",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7064",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2375",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.17677",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10064",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2746",
  "buying-experience-components": "/buying-experience-components/static-1.8484",
  "checkout-service-types": "/checkout-service-types/static-1.2830",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.7868",
  "trellis-story-utils": "/trellis-story-utils/static-1.3233",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12193",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5027",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.5795",
  "immutable-less": "/immutable-less/static-1.3239",
  "routing-ui": "/routing-ui/static-1.15492",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4433",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.4023",
  "re-reselect": "/re-reselect/static-1.4",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2611",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2098",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.1716",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2847",
  "recent-activities-card": "/recent-activities-card/static-1.52871",
  "submissions-lib": "/submissions-lib/static-1.41089",
  "ui-forms-components": "/ui-forms-components/static-1.8017",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.6516",
  "customer-success-client-types": "/customer-success-client-types/static-1.14261",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.11472",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.13078",
  "guided-actions-lib": "/guided-actions-lib/static-1.14287",
  "property-management-iframe": "/property-management-iframe/static-1.7858",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.71292",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.62033",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.71299",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.71313",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.71314",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.71313",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.49567",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.63288",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.38550",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.40179",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.40180",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.41610",
  "card-invoices-lib": "/card-invoices-lib/static-1.50695",
  "card-lists-lib": "/card-lists-lib/static-1.65628",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.50477",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.50476",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.31981",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.36295",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.31178",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.51357",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.78532",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.32563",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.71454",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.50547",
  "card-target-account-lib": "/card-target-account-lib/static-1.67287",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.68093",
  "card-workflows-lib": "/card-workflows-lib/static-1.67464",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.21488",
  "invoices-card-lib": "/invoices-card-lib/static-1.51234",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.31413",
  "orders-card-lib": "/orders-card-lib/static-1.16512",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.14025",
  "recording-preview-card": "/recording-preview-card/static-1.11398",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.35120",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.26477",
  "sales-execution-components": "/sales-execution-components/static-1.7762",
  "process-guide-chirp": "/process-guide-chirp/static-1.3282",
  "gapi-client-types": "/gapi-client-types/static-1.3",
  "google-picker-types": "/google-picker-types/static-1.3",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.1042",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11063",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13657",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.3557",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4388",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2375",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14969",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11845",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11841",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4465",
  "automation-ui-routing": "/automation-ui-routing/static-1.14803",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12525",
  "immerable": "/immerable/static-1.2836",
  "social-insights-client-types": "/social-insights-client-types/static-1.17407",
  "user-configuration-lib": "/user-configuration-lib/static-1.24203",
  "tinymce-themes": "/tinymce-themes/static-1.51216",
  "interframe": "/interframe/static-3.3482",
  "tinymce-data": "/tinymce-data/static-1.35331",
  "tinymce-plugins": "/tinymce-plugins/static-1.52360",
  "ContentData": "/ContentData/static-1.62799",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1418",
  "sales-views-client-types": "/sales-views-client-types/static-1.3026",
  "ui-signature-editor": "/ui-signature-editor/static-1.13384",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8768",
  "stripe-connect-js": "/stripe-connect-js/static-1.39",
  "form-builder-ui": "/form-builder-ui/static-1.7773",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15303",
  "property-management-common": "/property-management-common/static-1.144",
  "react-window": "/react-window/static-1.13",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9820",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.13616",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.7831",
  "app-users-service-client": "/app-users-service-client/static-1.3731",
  "app-users-service-types": "/app-users-service-types/static-1.3137",
  "framework-listing-lib": "/framework-listing-lib/static-2.21950",
  "mini-checkout-client": "/mini-checkout-client/static-1.23934",
  "onboarding-utils": "/onboarding-utils/static-1.4038",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.22158",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8122",
  "codemirror": "/codemirror/static-5.69",
  "layout-dnd-components": "/layout-dnd-components/static-1.10610",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9585",
  "react-codemirror": "/react-codemirror/static-1.9290",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2973",
  "academy-common-lib": "/academy-common-lib/static-1.9280",
  "customer-data-views-management": "/customer-data-views-management/static-1.21900",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6809",
  "touchless-buying-components": "/touchless-buying-components/static-1.3138",
  "merchandise-lib": "/merchandise-lib/static-1.223",
  "settings-content-modals": "/settings-content-modals/static-1.39470",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "layout-data-lib": "/layout-data-lib/static-1.7910",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "zustand": "/zustand/static-1.51",
  "crm-export-dialog": "/crm-export-dialog/static-1.4977",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5059",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "checkout-sdk": "/checkout-sdk/static-3.20777",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2561",
  "access-control-lib": "/access-control-lib/static-1.9136",
  "EmailComponents": "/EmailComponents/static-1.48523",
  "EmailData": "/EmailData/static-1.47199",
  "redux-less": "/redux-less/static-2.8124",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.606",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "ContentComponents": "/ContentComponents/static-2.65680",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7821",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.40092",
  "ui-tool-access": "/ui-tool-access/static-1.8737",
  "automation-ui-types": "/automation-ui-types/static-1.13443",
  "data-token-views": "/data-token-views/static-1.13897",
  "simple-menus-core": "/simple-menus-core/static-1.13416",
  "simple-menus-lib": "/simple-menus-lib/static-1.14933",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27890",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4803",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2462",
  "ContentEditorUI": "/ContentEditorUI/static-2.71140",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2826",
  "web-interactives-components": "/web-interactives-components/static-1.11312",
  "web-interactives-data": "/web-interactives-data/static-1.11313",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3744",
  "copilot-plugins": "/copilot-plugins/static-1.5761",
  "cta-picker": "/cta-picker/static-1.30901",
  "editor-components": "/editor-components/static-1.11694",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.6991",
  "error-messaging-js": "/error-messaging-js/static-1.3975",
  "pictos": "/pictos/static-7.159",
  "redux-request-state": "/redux-request-state/static-1.9263",
  "smart-content-core": "/smart-content-core/static-1.36856",
  "smart-content-lib": "/smart-content-lib/static-1.37509",
  "social-composer-lib": "/social-composer-lib/static-1.52930",
  "structured-content-lib": "/structured-content-lib/static-1.19769",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.47471",
  "tinymce-copilot": "/tinymce-copilot/static-1.11314",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.31377",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5777",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.4586",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.8050",
  "fuzzy": "/fuzzy/static-1.8",
  "codemirror-dlb": "/codemirror-dlb/static-1.52695",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
